import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConnectionCreatePage } from '@/features/data/connections/connection-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouvelle connexion de données (lot L07). */
export const Route = createFileRoute('/$tenant/projects/$projectId/connections/new')({
  component: NewConnectionRoute,
});

function NewConnectionRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="connections"
      crumbs={[{ label: t('nav.items.connections') }, { label: t('connections.newTitle') }]}
    >
      <ConnectionCreatePage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
